export const faqs = [
  {
    q: 'How will I receive the material?',
    a: 'After your payment is confirmed, you’ll receive instructions for accessing the digital files through the delivery method configured at checkout.',
  },
  {
    q: 'Is this suitable for nursing students?',
    a: 'Yes, the educational references may be useful for students studying critical care nursing concepts. They should be used alongside formal coursework, clinical supervision, and approved learning materials.',
  },
  {
    q: 'Is this suitable for experienced ICU nurses?',
    a: 'The collection may serve as a supplementary reference for nurses who want to review selected monitoring, assessment, and clinical reasoning concepts. It does not replace specialist training, current clinical guidelines, or institutional procedures.',
  },
  {
    q: 'Does the Blueprint™ cover every critical care nursing topic?',
    a: 'No. The collection focuses on selected foundations, hemodynamic monitoring, respiratory assessment, neurological and cardiovascular assessment, laboratory concepts, and educational case studies.',
  },
  {
    q: 'Can I use this resource to make clinical decisions?',
    a: 'The Blueprint™ is an educational product. It does not provide patient-specific medical advice or replace professional judgment, validated protocols, supervised clinical training, or institutional procedures.',
  },
  {
    q: 'Do I need to be an ICU specialist?',
    a: 'No specialist credential is required to study educational materials. However, some topics may be more suitable for readers who already have a foundation in nursing and physiology. Your clinical responsibilities must remain within your qualifications, training, and applicable professional scope.',
  },
  {
    q: 'Are the files downloadable?',
    a: 'The collection is offered as a digital product. The available file formats and download options depend on the delivery setup described at checkout.',
  },
  {
    q: 'Is it a one-time payment?',
    a: 'Yes. The advertised price is $27 USD as a one-time payment. There is no monthly subscription. Currency conversion to your local currency is handled automatically at checkout.',
  },
  {
    q: 'What happens if the product doesn’t meet my expectations?',
    a: 'Refund eligibility follows the published refund policy. If the seven-day guarantee is active, you can request a refund within the specified period according to its terms.',
  },
  {
    q: 'Will I receive future updates?',
    a: 'Future updates are not guaranteed unless explicitly included in the offer. Your purchase covers the materials and access terms specified at checkout.',
  },
];
